export default "__VITE_ASSET__Bbd7dEPQ__"